import { Injectable } from '@angular/core';
import { BehaviorSubject, pipe, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ReqResService } from '../req-res.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AppLayoutComponent } from '../../layout/app-layout/app-layout.component';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  helper = new JwtHelperService();
  isNotAuthencatedUrl: string = "";
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private reqRes: ReqResService) {
    let pathname = window.location.pathname;
    this.isNotAuthencatedUrl = pathname.replace("/","");
  }
  login(userDetails) {
    return this.reqRes.postData('/auth/login', userDetails).pipe(map(response => {
      console.log(response)
      if (response.islogin == 1) {
        localStorage.setItem('authToken', response.token);
        localStorage.setItem('userinfo', JSON.stringify(response.userinfo));
      }
      return response;
    }))
  }

  setUserData(userDetails) {
    localStorage.setItem('userinfo', JSON.stringify(userDetails));
  }
  public isAuthenticated(): boolean {
    const token = localStorage.getItem('authToken');
    return !this.helper.isTokenExpired(token);
  }
  getuserid(): number {
    return AppLayoutComponent._userId;
  }
  lastName(): string {
    return AppLayoutComponent._lastName;
  }
  firstName(): string {
    return AppLayoutComponent._firstName;
  }
  image(): string {
    return AppLayoutComponent._image;
  }
  //lastName(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].lastName;
  //  }
  //}
  //firstName(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].firstName;
  //  }
  //}
  //image(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].imgPath;
  //  }
  //}
  //typeid(): number {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].typeid;
  //  }
  //}
  //position(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].position;
  //  }
  //}
  //companyImage(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].companyImage;
  //  }
  //}
  //companyName(): string {
  //  if (localStorage.getItem('userinfo')) {
  //    return JSON.parse(localStorage.getItem('userinfo'))[0].companyName;
  //  }
  //}
  checkLoginEmail(data: any) {
    return this.http.post<any>('/auth/check-login-email', data);
  }
  setFirstPassword(data: any) {
    return this.http.post<any>('/auth/set-first-password', data);
  }


  forgotPassword(data: any) {
    return this.reqRes.postData('/auth/forgot-password', data);
  }
  resetPasswordByToken(data: any) {
    return this.reqRes.postData('/auth/reset-password-by-token', data);
  }
  signUpRequest(data: any) {
    return this.reqRes.postData('/auth/sign-up-request', data);
  }
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userinfo');
    this.router.navigate(['/login']);
  }
}
